import { render, staticRenderFns } from "./VueTreeList.vue?vue&type=template&id=63677fb6&"
import script from "./VueTreeList.vue?vue&type=script&lang=js&"
export * from "./VueTreeList.vue?vue&type=script&lang=js&"
import style0 from "./VueTreeList.vue?vue&type=style&index=0&id=63677fb6&prod&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports